import './style.css'

// shoppingcart
import ShoppingcartPopup from './src/shoppingcart-popup'
import ShoppingcartOption from './src/shoppingcart-option'
import ShoppingcartPopupProduct from './src/shoppingcart-popup-product'
import CheckoutProduct from './src/checkout-product'
import CheckoutAddress from './src/checkout-address'
import CheckoutShipping from './src/checkout-shipping'
import CheckoutParcelshop from './src/checkout-parcelshop'
import CheckoutParcelshopSelect from './src/checkout-parcelshop-select'
import CheckoutPayment from './src/checkout-payment'
import CheckoutPaymentGiftcard from './src/checkout-payment-giftcard'
import CheckoutContent from './src/checkout-content'
import CheckoutField from './src/checkout-field'
import LpTotop from './src/lp-totop'
import BackgroundClipPath from './src/background-clip-path'
import LpProgress from './src/lp-progress'
import LpHeroBanner from './src/lp-hero-banner'

import run from 'webiq.boilerplate'

run({
	ShoppingcartOption,
	ShoppingcartPopup,
	ShoppingcartPopupProduct,
	CheckoutProduct,
	CheckoutAddress,
	CheckoutShipping,
	CheckoutParcelshop,
	CheckoutParcelshopSelect,
	CheckoutPayment,
	CheckoutPaymentGiftcard,
	CheckoutContent,
	CheckoutField,
	LpTotop,
	BackgroundClipPath,
	LpProgress,
	LpHeroBanner
})
